import {http} from '../core/http';

export const tagService = {
  search(params: { name: string }) {
    return http.post('/uss/get_tags', params);
  }
};